export default {
    title: `Statistiques du mois sur mes réseaux`,
    legend: `Moyennes calculées sur le dernier mois, comparées au mois précédent.`,
    snaEmpty: `Vous n’avez pas encore ajouté de réseau`,
    seePerformance: `Voir la performance de tous mes posts`,
};
